import { Link } from 'react-router-dom';
import { estimateMinutes, newsArticle } from '@/content/news';
import { NEWS_META } from '@/content/site';
import { formatDate } from '@/lib/format';
import { Card } from '@/components/Card';
import { Icon } from '@/components/Icon';
import { Reveal } from '@/components/Reveal';
import { Section, SectionHeading } from '@/components/Section';
import { Seo } from '@/components/Seo';

export function NewsPage() {
  return (
    <>
      <Seo
        path="/news"
        crumbs={[
          { name: '首页', path: '/' },
          { name: '动态', path: '/news' },
        ]}
      />

      <Section tone="grid" spacing="tight" className="border-b border-line">
        <div className="max-w-3xl">
          <span className="label-mono">动态</span>
          <h1 className="mt-3 text-3xl font-semibold leading-tight text-fg md:text-[2.5rem] md:leading-[1.15]">
            工程笔记与产品动态
          </h1>
          <p className="mt-4 text-base leading-relaxed text-fg-muted">
            平台如何实现、为何如此取舍，以及哪些我们没有选择去做 —— 均记录于此。我们不对发布节奏作出承诺，写清楚一篇便发布一篇。
          </p>
        </div>
      </Section>

      <Section>
        <SectionHeading eyebrow={`共 ${NEWS_META.length} 篇`} title="全部文章" />

        <div className="mt-10 flex flex-col gap-4">          {NEWS_META.map((item, index) => {
            const article = newsArticle(item.slug);

            return (
              <Reveal key={item.slug} delay={index} as="div">
                <Card interactive className="group">
                  <article className="flex flex-col gap-3">
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-xs text-fg-subtle">
                      <span className="metric-value">{formatDate(item.date)}</span>
                      {article ? (
                        <>
                          <span aria-hidden="true">·</span>
                          <span>约 {estimateMinutes(article.blocks)} 分钟</span>
                        </>
                      ) : null}
                    </div>

                    <h2 className="text-lg font-semibold text-fg">
                      <Link to={`/news/${item.slug}`} className="transition-colors hover:text-accent">
                        {item.title}
                      </Link>
                    </h2>

                    <p className="text-sm leading-relaxed text-fg-muted">{item.excerpt}</p>

                    <div className="mt-1 flex flex-wrap items-center justify-between gap-3">
                      <div className="flex flex-wrap gap-2">
                        {item.tags.map((tag) => (
                          <span
                            key={tag}
                            className="rounded-md bg-grad-tint px-2.5 py-1 text-xs font-medium text-brand"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                      <Link
                        to={`/news/${item.slug}`}
                        className="inline-flex items-center gap-1.5 text-sm font-medium text-fg transition-colors hover:text-accent"
                      >
                        阅读
                        <Icon name="arrowRight" size={14} />
                      </Link>
                    </div>
                  </article>
                </Card>
              </Reveal>
            );
          })}
        </div>
      </Section>
    </>
  );
}
